import RequiredMessage from './RequiredMessage';

export default RequiredMessage;
